const CHANNEL_NAME = 'auth_channel';

let channel: BroadcastChannel | null = null;

export const getAuthChannel = (): BroadcastChannel | null => {
  if (typeof window === 'undefined') return null;

  if (!('BroadcastChannel' in window)) return null;

  if (!channel) {
    channel = new BroadcastChannel(CHANNEL_NAME);
  }

  return channel;
};